import SaveFilterSetModal from '@/pages/Data/components/SaveFilterSetModal.js';
import type { AppliedFilter, FilterArrayItem } from '../types';

type SaveFilterSetModalProps = React.ComponentProps<typeof SaveFilterSetModal>;

type ShipmentSaveFilterSetModalProps = {
  sentimentSelected: SaveFilterSetModalProps['sentimentSelected'];
  aiStateSelected: SaveFilterSetModalProps['aiStateSelected'];
  open: boolean;
  onClose: () => void;
  presets: SaveFilterSetModalProps['presets'];
  appliedFilters: AppliedFilter[];
  filterArray: FilterArrayItem[];
  selectedPresetId: SaveFilterSetModalProps['selectedPresetId'];
  handleSavePreset: (payload: {
    name: string;
    filterArray: FilterArrayItem[];
    appliedFilters: AppliedFilter[];
  }) => Promise<boolean>;
  setLastSavedFiltersSignature: (signature: string) => void;
};

const ShipmentSaveFilterSetModal: React.FC<ShipmentSaveFilterSetModalProps> = ({
  sentimentSelected,
  aiStateSelected,
  open,
  onClose,
  presets,
  appliedFilters,
  filterArray,
  selectedPresetId,
  handleSavePreset,
  setLastSavedFiltersSignature,
}) => (
  <SaveFilterSetModal
    sentimentSelected={sentimentSelected}
    aiStateSelected={aiStateSelected}
    open={open}
    onClose={onClose}
    presets={presets}
    appliedFilters={appliedFilters}
    filterArray={filterArray}
    selectedPresetId={selectedPresetId}
    onSave={async ({ name }) => {
      const extra: FilterArrayItem[] = [];

      if (aiStateSelected?.length) {
        extra.push({
          filterBy: 'ai_state',
          filterValue: aiStateSelected,
        });
      }

      if (sentimentSelected?.length) {
        extra.push({
          filterBy: 'sentiment',
          filterValue: sentimentSelected,
        });
      }

      const nextFilterArray: FilterArrayItem[] = [
        ...(filterArray || []).filter(
          (filter) =>
            filter.filterBy !== 'ai_state' && filter.filterBy !== 'sentiment'
        ),
        ...extra,
      ];

      const ok = await handleSavePreset({
        name,
        filterArray: nextFilterArray,
        appliedFilters,
      });

      if (ok) {
        setLastSavedFiltersSignature(
          JSON.stringify({ appliedFilters, filterArray: nextFilterArray })
        );
      }
    }}
  />
);

export default ShipmentSaveFilterSetModal;
